const japanPrefectures = {
  hokkaido: '北海道',
  aomori: '青森縣',
  iwate: '岩手縣',
  miyagi: '宮城縣',
  akita: '秋田縣',
  yamagata: '山形縣',
  fukushima: '福島縣',
  ibaraki: '茨城縣',
  tochigi: '栃木縣',
  gunma: '群馬縣',
  saitama: '埼玉縣',
  chiba: '千葉縣',
  tokyo: '東京都',
  kanagawa: '神奈川縣',
  niigata: '新潟縣',
  toyama: '富山縣',
  ishikawa: '石川縣',
  fukui: '福井縣',
  yamanashi: '山梨縣',
  nagano: '長野縣',
  gifu: '岐阜縣',
  shizuoka: '靜岡縣',
  aichi: '愛知縣',
  mie: '三重縣',
  shiga: '滋賀縣',
  kyoto: '京都府',
  osaka: '大阪府',
  hyogo: '兵庫縣',
  nara: '奈良縣',
  wakayama: '和歌山縣',
  tottori: '鳥取縣',
  shimane: '島根縣',
  okayama: '岡山縣',
  hiroshima: '廣島縣',
  yamaguchi: '山口縣',
  tokushima: '德島縣',
  kagawa: '香川縣',
  ehime: '愛媛縣',
  kochi: '高知縣',
  fukuoka: '福岡縣',
  saga: '佐賀縣',
  nagasaki: '長崎縣',
  kumamoto: '熊本縣',
  oita: '大分縣',
  miyazaki: '宮崎縣',
  kagoshima: '鹿兒島縣',
  okinawa: '沖繩縣'
};

export default japanPrefectures;
